/**
 * @date: 3/12/21
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2021 MaxMD Corporation, All Rights Reserved.
 *
 */
import {isMasterAdmin} from "./portal-helper";

export const PortalUrl = {
    Home : "/",
    SignInWithIdme : "/auth/signInWithIdme",
    SignInWithGoogle : "/auth/signInWithGoogle",
    SignInWithLinkedIn : "/auth/signInWithLinkedIn",
    SignOut : "/auth/signOut",
    NotificationHome : "/notification",
    NotificationVisitBase : "/notification/visit",
    NotificationVisitHome : "/notification/visits",
    NotificationAdtBase : "/notification/adt",
    NotificationAdtHome : "/notification/adts",
    NotificationOutboundAdtHome : "/notification/outAdts",
    // NotificationProviderBase : "/notification/provider",
    // NotificationProviderHome : "/notification/providers",
    // NotificationViewProvider : {
    //     pattern: "/notification/provider/:providerNpi",
    //     getPath: function (providerNpi, backUri){
    //         return `/notification/provider/${providerNpi}?back=${backUri ? encodeURIComponent(backUri) : ''}`;
    //     }
    // },
    NotificationProvider: {
        base: '/notification/provider',
        home: '/notification/providers',
        viewProvider: {
            pattern: "/notification/provider/:providerNpi",
            getPath: function (providerNpi, backUri){
                return `/notification/provider/${providerNpi}?back=${backUri ? encodeURIComponent(backUri) : ''}`;
            }
        },
        ImportFormStepper: `/notification/providerImport`,
        ImportFormStepperReview: {
            pattern: `/notification/providerImport/:id`,
            getPath: function(id){
                return `/notification/providerImport/${id}`
            }
        }
    },
    NotificationPatientBase : "/notification/patient",
    NotificationPatientHome : "/notification/patients",
    NotificationPatient: {
        ImportFormStepper: `/notification/patientImport`,
        ImportFormStepperReview: {
            pattern: `/notification/patientImport/:id`,
            getPath: function(id){
                return `/notification/patientImport/${id}`
            }
        }
    },
    ReferralHome : "/referral",
    MessageHome : "/message",
    MessageFolder: {
        pattern: "/message/:directAddress/:direction",
        getPath: function (folder){
            return `/message/${encodeURIComponent(folder.directAddress)}/${folder.inbound? "in" : "out"}`
        }
    },
    // ContextIg: {
    //     Subscription: {
    //         Request: {
    //             View: {
    //                 pattern: `/subscription/viewRequest/:id`,
    //                 getPath: function(id){
    //                     return `/subscription/viewRequest/${id}`
    //                 }
    //             }
    //         }
    //     }
    // },
    Subscription: {
        base: '/subscription',
        Home: {
            pattern: `/subscription`,
        },
        ViewRequest: {
            pattern: `/subscription/viewRequest/:id`,
            getPath: function(id){
                return `/subscription/viewRequest/${id}`
            }
        }
    },
    Organization: {
        base: '/organization',
        Home: {
            pattern: `/organization`,
        },
    },
    Users: {
        base: '/Users',
        Home: {
            pattern: `/Users`,
            pattern_with_orgId: `:orgId`,
        }
    },
    ExternalSource: {
        base: '/externalSource',
        Home: {
            pattern: '/externalSource'
        },
        NPPESNPI: {
            pattern_home: `/externalSource/NPPESNPI`,
            pattern_new_task: `/externalSource/NPPESNPI/NPPESNPINewImportTask`,
        },
        NUCCSpecialty: {
            pattern_home: '/externalSource/NUCCSpecialty',
            pattern_new_task: '/externalSource/NUCCSpecialty/NUCCSpecialtyNewImportTask',
        },
        ServDescription: {
            pattern_home: '/externalSource/ServDescription',
            pattern_new_task: '/externalSource/ServDescription/ServDescriptionNewImportTask'
        },
        Suffix: {
            pattern_home: '/externalSource/Suffix',
            pattern_new_task: '/externalSource/Suffix/SuffixNewImportTask'
        },
        OrgType: {
            pattern_home: '/externalSource/OrgType',
            pattern_new_task: '/externalSource/OrgType/OrgTypeNewImportTask'
        },
        // Amendment #1 A5. One route pair for every value set in utils/terminology.js, rather than a
        // pair per value set as above — :name is the backend TerminologyImport constant.
        Terminology: {
            pattern_home: '/externalSource/terminology/:name',
            pattern_new_task: '/externalSource/terminology/:name/NewImportTask',
            getHome: function (name) {
                return `/externalSource/terminology/${name}`
            },
            getNewTask: function (name) {
                return `/externalSource/terminology/${name}/NewImportTask`
            }
        },
        Credentials: {
            pattern_home: '/externalSource/credentials',
        },
        DepartmentNames: {
            pattern_home: '/externalSource/departmentNames',

        },
        getSourceHome: {
            getPath: function (source) {
                return `/externalSource/${source}`
            }
        }
    },
    ValidationRules: {
        base: '/validationRules',
        Home: {
            pattern: '/validationRules',
        },
    },
    Published: {
        base: '/published',
        Home: {
            pattern: '/published',
            getPath: function (){
                return "/published"
            }
        },
        Publication: {
            pattern: '/published/:id/',
            getPath: function(id){
                return `/published/${id}/`
            }
        },
        HocReport: {
            base: '/report/adHoc/publication',
            pattern: '/report/adHoc/publication/:id',
            getPath: function(id) {
                return `/report/adHoc/publication/${id}`
            }
        }

    },
    Contributions: {
        base: '/contributions',
        Home: {
            pattern: '/contributions',
            getPath: function (){
                return "/contributions"
            },
            lastPublishedContributions: '/contributions'
        },
        HocReport: {
            base: '/report/adHoc/contribution',
            pattern: '/report/adHoc/contribution/:id',
            getPath: function(id) {
                return `/report/adHoc/contribution/${id}`
            }
        }
    },
    AuditLogs: {
        base: '/auditLogs',
        Home: {
            pattern: '/auditLogs'
        }

    },
    Hisps: {
        base: '/hisps',
        Home: {
            pattern: '/hisps',
        },
    },
    NotificationViewPatient : {
        pattern: "/notification/patient/:patientId",
        getPath: function (patientId){
            return `/notification/patient/${patientId}`;
        }
    },

    NotificationViewAdt : {
        pattern: "/notification/adt/:v2MessageId",
        getPath: function (id){
            return `/notification/adt/${id}`;
        }
    },
    Batch: {
        ViewTask: {
            pattern: "/task/:id"
        }
    }

}

export const ApiUrl={
    Users: {
        query: {
            endpoint: '/api/users/spec',
            getPath: function (query, page, account){
                const queryAnd = query ? `&${query}` : "";
                const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}${orgAnd}`;
            }
        },
        addUser: {
            getPath: function () {
                return `/api/users/addUser`;
            }
        },
        deleteUser: {
            getPath: function (userId) {
                return `/api/users/${userId}`;
            }
        }
    },
    Adt: {
        incoming: {
            query: {
                endpoint: '/api/notification/adt/spec'
            },
            getMessage: {
                pattern: '/api/notification/adt/{adtId}',
                getPath: function(id, account){
                    const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                    return `/api/notification/adt/${id}${orgQuery}`;
                }
            },
            getRaw: {
                pattern: '/api/notification/adt/{adtId}/raw',
                getPath: function(id, account){
                    const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                    return `/api/notification/adt/${id}/raw${orgQuery}`;
                }
            },
        },
        outgoing: {
            query: {
                endpoint: '/api/outboundNotification/adt/spec',
                getPath: function (query, page, account){
                    const queryAnd = query ? `&${query}` : "";
                    const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                    return `${this.endpoint}?page=${page}${queryAnd}${orgAnd}`;
                }
            },
            getRaw: {
                pattern: '/api/outboundNotification/adt/{adtId}/raw',
                getPath: function(id, account){
                    const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                    return `/api/outboundNotification/adt/${id}/raw${orgQuery}`;
                }
            },
        }
    },
    Batch: {
        getBatch: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/batch/${id}${orgQuery}`;
            }
        },
        getBatchById: {
            getPath: function (id) {
                return `/api/batch/${id}`;
            }
        },
        getAllActiveBatch: {
            getPath: "/api/batch",
        },
        cancelBatch: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/batch/${id}/cancel${orgQuery}`;
            }
        },
        cancelAllBatchProcesses: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/batch/cancelAll${orgQuery}`;
            }
        },
    },
    ExternalSource: {
        getAllSources: {
            getPath: function () {
                return "/api/externalDataSource"
            },
        },
        getSourceLogs: {
            getPath: function (source) {
                return `/api/externalDataSource/${source}`
            }
        },
        getExternalSourceLogs: {
            getPath: function (source, query, page) {
                const queryAnd = query ? `&${query}` : "";
                return `/api/externalDataSource/${source}?page=${page}${queryAnd}`
            }

        },
        importNpiUrl: {
            incremental: "/api/externalDataSource/npi/import/incremental",
            full: "/api/externalDataSource/npi/import/full"
        },
        importTaxonomyUrl: "/api/externalDataSource/taxonomy/import",
        importServDescription: "/api/externalDataSource/DirectUsecase/import",
        importSuffix: "/api/externalDataSource/Suffix/import",
        importOrgType: "/api/externalDataSource/OrgType/import",
        // Body optional: posted empty, the server derives the download address from the artifact's
        // own canonical. A body overrides it, for a pre-release or locally hosted draft.
        importTerminology: {
            getPath: function (name) {
                return `/api/externalDataSource/terminology/${name}/import`
            }
        },
        getLink: {
            getPath: function (name) {
                return `/api/setting/${name}`;
            }
        },
        saveLink: {
            getPath: function (name, type) {
                return `/api/setting/${name}/${type}`;
            }
        },
        getCompleteLogs: {
            getPath: '/api/externalDataSource/recentLogs'
        },
    },
    Hisps: {
        query: {
            endpoint: "/api/hisp",
            getPath: function (query, page) {
                const queryAnd = query ? `&${query}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}`;
            }
        },
        crateHisp: {
            getPath: '/api/hisp'
        },
        fhirConfig:{
            getPath: '/api/hisp/fhir'
        },
        assignCert: {
            getPath: function (hispId) {
                return `/api/hisp/${hispId}/certificate`;
            }
        },
        assignCertWithFile: {
            getPath: function (hispId) {
                return`/api/hisp/${hispId}/certificateFile`
            }
        },
        deleteHisp: {
            getPath: function (hispId) {
                return `/api/hisp/${hispId}`;
            }
        },
        updateHisp: {
            getPath: function (hispId) {
                return `/api/hisp/${hispId}/setting`;
            }
        },
        currentSync: {
            getPath: '/api/hisp/chartData'
        },
        intervalData: {
            getPath: '/api/hisp/intervalData'
        }
    },
    ValidationRules: {
        query: {
            endpoint: "/api/rule",
            getPath: function () {
                return `${this.endpoint}`
            }
        }

    },
    Contributions: {
        query: {
            endpoint: "/api/contribution/",
            getPath: function (query, page) {
                const queryAnd = query ? `&${query}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}&origin=1`;
            }
        },
        getDetailedReport: {
            getPath: function (id) {
                return `/api/contribution/${id}/DetailedReport`;
            }
        },
        getExceptionReport: {
            getPath: function (id) {
                return `/api/contribution/${id}/ExceptionReport`;
            }
        },
        // Rows that never reached the published directory — SOW #4 deliverable 2.c.
        // 404s when nothing was omitted, so only link it when omittedRowsDataPath is set.
        getOmittedRows: {
            getPath: function (id) {
                return `/api/contribution/${id}/OmittedRows`;
            }
        },
        getContributionById: {
            getPath: function (id) {
                return `/api/contribution/${id}`
            }
        },
        getSummaryReport: {
            getPath: function (id) {
                return `/api/contribution/${id}/SummaryReport`;
            }
        },
        getInputFile: {
            getPath: function (id) {
                return `/api/contribution/${id}/input`;
            }
        },
        getAllHisps: {
            getPath: function () {
                return `/api/contribution/allHisps`;
            }
        },
        getContributionsForPublish: {
            getPath: function (publishId) {
                return `/api/contribution/publish/${publishId}`;
            }
        },
        contributionExport: {
            getPath: function (query) {
                const queryAnd = query ?? "";
                return `/api/contribution/export/selected?${queryAnd}`
            }
        },
        getBinaryReport: {
            getPath: function (id) {
                return `/api/binary/${id}/download`;
            }
        },
    },
    Published: {
        lastPublished: {
            endpoint: '/api/publish/lastPublish/info?stat=true'
        },
        query: {
            endpoint: '/api/publish',
            getPath: function (query, page) {
                const queryAnd = query ? `&${query}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}`
            }
        },
        getPublicationById: {
            getPath: function (id) {
                return `/api/publish/${id}`
            }
        },
        getBinaries: {
            getPath: function (query, page, hispName) {

                const queryAnd = query ? `&${query}${hispName}` : `${hispName}`;
                return `/api/binary?page=${page}${queryAnd}`
            }
        },
        getPublication: {
            getPath: function (id, withStat, withContributions) {
                var query = false;
                if (withStat){
                    query = `${query ? `${query}&` : ''}stat=true`;
                }
                if (withContributions){
                    query = `${query ? `${query}&` : ''}contributions=true`;
                }
                const base = id === "last" ? "/api/publish/lastPublish/info" : `/api/publish/${id}`;
                return `${base}?${query}`
            }
        },
        getV1Report: {
            getPath: function (id) {
                return `/api/publish/${id}/V1`
            }
        },
        getV2Report: {
            getPath: function (id) {
                return `/api/publish/${id}/V2`
            }
        },
        getAddReport: {
            getPath: function (id) {
                return `/api/publish/${id}/Add`
            }
        },
        getInactiveReport: {
            getPath: function (id) {
                return `/api/publish/${id}/Inactive`
            }
        },
        getSummaryReport: {
            getPath: function (id) {
                return `/api/publish/${id}/SummaryReport`
            }
        },
        getSummaryByRuleReport: {
            getPath: function (id) {
                return `/api/publish/${id}/SummaryByRuleReport`
            }
        },
        getSummaryByFieldReport: {
            getPath: function (id) {
                return `/api/publish/${id}/SummaryByFieldReport`
            }
        },
        getDetailedReport: {
            getPath: function (id) {
                return `/api/publish/${id}/DetailedReport`
            }
        },
        // The audience-filtered Aggregated Directories. 404 for a publish that ran before the split, so
        // only link them when the publish carries the path.
        getAudienceDirectory: {
            getPath: function (id, audience) {
                return `/api/publish/${id}/Audience/${audience}`
            }
        },
    },
    AuditLogs: {
        query: {
            endpoint: "/api/audit",
            getPath: function (query, page) {
                const queryAnd = query ? `&${query}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}`;
            }
        },
    },
    Message: {
        Folder: {
            query: {
                endpoint: '/api/message',
                getPath: function (directAddress, inbound, query, page, account){
                    const params = [];
                    if (query){
                        params.push(query);
                    }
                    if (page > 0){
                        params.push(`page=${page}`);
                    }
                    if (account && isMasterAdmin(account.user) && account.organization){
                        params.push(`organization=${account.organization.id}`)
                    }

                    console.log("#############", params);
                    const paramString = params.join("&");
                    return `${this.endpoint}/account/${directAddress}/${inbound ? "in" : "out"}?${paramString}`;
                }
            },
        },
        ContextIg: {
            get: function (messageId){
                return `/api/message/m/${messageId}/contextIg`
            },
            subscriptionRequest: {
                approve: function (messageId){
                    return `/api/message/m/${messageId}/contextIg/subscriptionRequest/approve`
                },
                dismiss: function (messageId){
                    return `/api/message/m/${messageId}/contextIg/subscriptionRequest/dismiss`
                },
                reject: function (messageId){
                    return `/api/message/m/${messageId}/contextIg/subscriptionRequest/reject`
                },
            },
        }
    },
    Subscription: {
        query:{
            endpoint: '/api/subscription/spec',
            getPath: function (query, page, account){
                const queryAnd = query ? `&${query}` : "";
                const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}${orgAnd}`;
            }
        }
    },

    Patient: {
        getPatientById: {
            pattern: '/api/patient/adt/{patientId}',
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/patient/adt/${id}${orgQuery}`;
            }
        },
        export: {
            endpoint: '/api/patient/export/spec'
        },
        sendSubscription: {
            getPath: function(query, account){
                const queryAnd = query ? `&${query}` : "";
                const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                return `/api/patient/sendSubscriptionRequest/spec?${queryAnd}${orgAnd}`;
            }
        },
        queryEndpoint: '/api/patient',
        uploadForm: {
            endpoint: `/api/patient/uploadForm`,
            getPath: function (account) {
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/patient/uploadForm${orgQuery}`
            }
        },
        viewUploadedForm: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/patient/form/${id}${orgQuery}`;
            }
        },
        importUploadedForm: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/patient/form/${id}/import${orgQuery}`;
            }
        },
        deleteUploadedForm: {
            getPath: function (id, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/patient/form/${id}${orgQuery}`;
            }
        },
    },
    Provider: {
        query: {
            endpoint: '/api/receiverProvider/spec',
            getPath: function (query, page, account){
                const queryAnd = query ? `&${query}` : "";
                const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}${orgAnd}`;
            }
        },
        updateDirectAddress: {
            getPath: function (id, directAddress, account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/receiverProvider/${id}/updateDirectAddress/${encodeURIComponent(directAddress)}${orgQuery}`;
            }
        },
        setDoNotSend: {
            getPath: function (id, on){
                return `/api/receiverProvider/${id}/DoNotSend/${on ? 'true' : 'false'}`;
            }
        },
        queryDirectAddress: {
            getPath: function (account){
                const orgQuery = account && isMasterAdmin(account.user) && account.organization ?  `?organization=${account.organization.id}` : "";
                return `/api/receiverProvider/queryDirectAddress/start${orgQuery}`;
            }
        },
        export: {
            endpoint: '/api/receiverProvider/export/spec',
            getPath: function (query, account){
                const params = [];
                if (query){
                    params.push(query);
                }
                if (account && isMasterAdmin(account.user) && account.organization){
                    params.push(`organization=${account.organization.id}`)
                }
                const paramString = params.join("&");
                return `${this.endpoint}?${paramString}`;
                // const queryAnd = query ? `&${query}` : "";
                // const orgAnd = account && isMasterAdmin(account.user) && account.organization ?  `&organization=${account.organization.id}` : "";
                // return `${this.endpoint}?${queryAnd}${orgAnd}`;
            }
        },
        getProviderAndAdts: {
            getPath: function (npi, page){
                return `/api/receiverProvider/providerAndAdts?npi=${npi}&page=${page}`;
            }
        },
        uploadForm: {
            endpoint: `/api/receiverProvider/uploadForm`
        },
        viewUploadedForm: {
            getPath: function (id){
                return `/api/receiverProvider/form/${id}`;
            }
        },
        importUploadedForm: {
            getPath: function (id){
                return `/api/receiverProvider/form/${id}/import`;
            }
        },
        deleteUploadedForm: {
            getPath: function (id){
                return `/api/receiverProvider/form/${id}`;
            }
        },
    },
    Organization: {
        switchTo: {
            getPath: function (id){
                return `/api/account/switch/organization/${id}`;
            }
        },
        masterAdminSwitchTo: {
            getPath: function (id){
                return `/api/account/masterAdmin/switch/organization/${id}`;
            }
        },
        query:{
            endpoint: '/api/organization/spec',
            getPath: function (query, page){
                const queryAnd = query ? `&${query}` : "";
                return `${this.endpoint}?page=${page}${queryAnd}`;
            }
        }
    },
    Activation: {
        Token: {
            SignUp: {
                Verify: {
                    getPath: function(token){
                        return `/activate/validateToken/Signup/${token}`;
                    }
                }
            },
            GetTokenLink:{
                getPath: function(userId) {
                    return `/activate/getTokenLink/${userId}`;
                }
            }

        }
    }
}
